<section class="sales-support-header">
    <app-header
        [title]="'sales-support.title' | translate"
    />
</section>
<section class="content">
    <section class="sales-support-form">
        <section class="sales-support-intro">
            <p class="typography-title-m">{{ 'sales-support.subtitle' | translate }}</p>
        </section>    

        <section class="sales-support-atts">
            <form class="sales-support-atts-form" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="name">{{ 'sales-support.name' | translate }}</label>
                    <input type="text"
                           id="name" 
                           name="name" 
                           [(ngModel)]="name"
                           [disabled]="true"
                           aria-label="name"/>
                </div>

                <div class="sales-support-atts-row">
                    <div class="form-group">
                    <label for="phone">{{ 'sales-support.phone' | translate }}</label>
                    <input type="text"
                           id="phone" 
                           name="phone" 
                           [(ngModel)]="phone"
                           [disabled]="true"
                           aria-label="phone"/>
                    </div>

                    <div class="form-group">
                        <label for="email">{{ 'sales-support.email' | translate }}</label>
                        <input type="text"
                            id="email" 
                            name="email" 
                            [(ngModel)]="email"
                            [disabled]="true"
                            aria-label="email"/>
                    </div>
                </div>
                

                <div class="form-group">
                    <label for="reason">{{ 'sales-support.reason' | translate }}</label>
                    <div class="custom-select" [class.empty]="!reasons">
                        <app-select
                        [placeholder]="'sales-support.reason_placeholder' | translate"
                        [options]="reasons"
                        [required]="true"
                        [isClearable]="false"
                        [searchable]="false"
                        [selectedValue]="selectedReason"
                        (selectedValueChanged)="onReasonChange($event)"
                        />
                    </div>
                </div>

                <div class="form-group">
                    <label for="subject">{{ 'sales-support.subject' | translate }}</label>
                    <textarea id="subject"
                        name="subject"
                        class="subject-text-area"
                        placeholder="{{ 'sales-support.subject_placeholder' | translate }}"
                        [(ngModel)]="subject"
                        aria-label="subject"></textarea>
                </div>

                <app-button [primary]="true" skin="ctop" size="l" type="submit"
                        [disabled]="!selectedReason"
                        [ngClass]="{ 'active': selectedReason }">
                        {{ 'sales-support.button_submit' | translate }}
                </app-button>
            </form>
        </section>
    </section>
</section>

<app-confirm-modal
  [isOpen]="isConfirmModalVisible"
  title="{{ 'sales-support.modal_confirm_title' | translate }}"
  confirmText="{{ 'sales-support.modal_confirm_accept' | translate }}"
  cancelText="{{ 'sales-support.modal_confirm_cancel' | translate }}"
  [buttonsInRow]="true"
  (onConfirm)="onConfirm()"
  (onCancel)="isConfirmModalVisible = false"
  (onClose)="isConfirmModalVisible = false"
/>